import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Tab } from "@mui/material";
import BryxIcon from "./BryxIcon/BryxIcon";
const BryxTab = styled((props) => {
    let { completed, pageCount, bold, ...tabProps } = props;
    if (completed) {
        tabProps["icon"] = _jsx(BryxIcon, { iconName: "check_circle", smIconSize: true, selected: tabProps.selected });
        tabProps["iconPosition"] = "end";
    }
    if (pageCount) {
        tabProps["label"] = tabProps["label"] + ` (${pageCount})`;
    }
    if (bold) {
        tabProps.sx = {
            ...tabProps.sx,
            fontWeight: "bold",
        };
    }
    return _jsx(Tab, { ...tabProps });
})(({ theme }) => {
    return {};
});
export default BryxTab;
